export {default as default} from './SectionBlog'
